// noinspection NonAsciiCharacters,JSNonASCIINames

export const translation_en = {
    // dashboard
    "ログアウト": "Logout",
    "新規作成": "New",
    "編集": "Edit",
    "共有": "Share",
    "複製": "Duplicate",
    "のコピー": "copy of {{value}}",
    "削除": "Delete",
    "プライベート" : "Private",
    "共有中" : "Shared",

    // dashboard/削除確認ダイアログ
    "削除確認": "Deletion Confirmation",
    "復元できません。本当に削除しますか？" : "It cannot be restored. Do you really want to delete it?",
    "キャンセル": "Cancel",

    // dashboard/アクセス権を削除確認ダイアログ
    "「マップ名」へのアクセス権を本当に削除しますか？": "Do you really revoke access to [{{value}}]",
    "あなた": "YOU",

    // dashboard/footer
    "トップ": "Top",
    "運営": "About Us",
    "利用規約": "Terms",
    "プライバシーポリシー": "Privacy",
    "お問い合わせ": "Contact Us",

    // tooltip
    "ダッシュボード": "Dashboard",
    "一つ戻す": "Undo",
    "一つ進む": "Redo",
    "フォント": "Font",
    "文字サイズ": "Font size",
    "テキストの色": "Text color",
    "太字": "Bold",
    "左寄せ": "Align left",
    "中央寄せ": "Center",
    "右寄せ": "Align right",
    "選択したセルとひとつ右のセルを結合": "Merge cells",
    "選択した結合セルの最も右のセルを結合解除": "Unmerge cells",
    "全て表示": "Unhide all",
    "背景を選択": "Select background",
    "配色を選択": "Select color",
    "オンラインN人": "Online {{value}} people(s)",
    "ズーム": "Zoom",
    "ペルソナ設定": "Persona settings",

    // header toolbar
    "ゴシック": "Sans serif",
    "明朝": "Serif",
    // ----
    "小": "Small",
    "標準": "Standard",
    "大": "Large",
    "特大": "XLarge",
    // ----
    "列・行を追加": "Add Column or Row",
    "列を追加": "Add Column",
    "左に追加": "Add to left",
    "右に追加": "Add to right",
    "行を追加": "Add Row",
    "フロー行を上に追加": "Add flow to above",
    "フロー行を下に追加": "Add flow to below",
    "空白行を上に追加": "Add perception to above",
    "空白行を下に追加": "Add perception to below",
    "行動行を上に追加": "Add behavior to above",
    "行動行を下に追加": "Add behavior to below",
    "施策行を上に追加": "Add action to above",
    "施策行を下に追加": "Add action to below",

    // ----
    "背景": "Background",
    "配色": "Color",
    "ショートカット": "Shortcut",
    "共有設定": "Share",
    "画像(png)でダウンロード": "Download as image(png)",

    // map
    "ファネル": "Funnel",
    "1行表示": "1行表示",
    "2行表示": "2行表示",

    // grab ui
    "左右移動": "Move horizontal",
    "上下移動": "Move vertical",
    "表示": "Unhide",
    "非表示": "Hide",
    //"削除": "削除",
    "追加": "Add",

    "説明を追加": "add description",

    // collaborator
    "共有ユーザ設定": "Collaboration user settings",
    "共有するユーザ、リストを入力": "input collaboration user or list",
    "リストに追加": "Add list",
    "オーナー": "Owner",
    "編集者": "Editor",
    "閲覧者": "Viewer",
    "アクセス権を削除": "Remove access",
    "設定を更新": "Apply settings",

    "マップの削除、共有ユーザの追加や権限の変更はオーナーのみが行えます": "Only the owner can delete map, add collaborator and change permissions",
    "オーナーからあなたに共有されたマップの共有を拒否する場合は『「アクセス権」削除』を選択してください": "If you want to refuse to share a map that has been shared with you by the owner, please select \"Remove access\".",

    "オンラインユーザー": "Online user",

    // shortcut
    "キーボードショートカット": "Keyboard Shortcut",
}
